import { h, Component } from 'preact'

class CookiePolicy extends Component {
  render() {
    return (
      <div>
        <h1>Cookie Policy<small> Lead Information about our use of cookies</small></h1>

        <p>OAGO uses cookies to distinguish you from other users of our site. This helps us to provide you with a good experience when you browse OAGO and also allows us to improve OAGO. By continuing to browse OAGO, you are agreeing to our use of cookies.</p>
        <p>A cookie is a small file of letters and numbers that we store on your browser or the hard drive of your computer if you agree. Cookies contain information that is transferred to your computer's hard drive.</p>

        <h4>We use the following cookies:</h4>

        <ul>
          <li>Strictly necessary cookies. These are cookies that are required for the operation of OAGO. They include, for example, cookies that enable you to log into secure areas of OAGO.</li>
          <li>Analytical/performance cookies. They allow us to recognise and count the number of visitors and to see how visitors move around OAGO when they are using it. This helps us to improve the way OAGO works, for example, by ensuring that users are finding what they are looking for easily.</li>
          <li>Functionality cookies. These are used to recognise you when you return to OAGO. This enables us to personalise our content for you, greet you by name and remember your preferences (for example, your choice of language or region).</li>
          <li>Targeting cookies. These cookies record your visit to OAGO, the pages you have visited and the links you have followed. We will use this information to make OAGO and the advertising displayed on it more relevant to your interests. We may also share this information with third parties for this purpose.</li>
          <li>You can find more information about the individual cookies we use and the purposes for which we use them in the table below:</li>
          <table class='table table-bordered'>
            <thead>
              <tr>
                <td>Name</td>
                <td>Purpose</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>session::oilandgasorganiser</td>
                <td>Enable the website you are visiting to keep track of your movement from page to page so you don't get asked for the same information you've already given to the site.</td>
              </tr>
            </tbody>
          </table>
        </ul>

        <p>Please note that third parties (including, for example, advertising networks and providers of external services like web traffic analysis services) may also use cookies, over which we have no control. These cookies are likely to be analytical/performance cookies or targeting cookies.</p>
        <p>You block cookies by activating the setting on your browser that allows you to refuse the setting of all or some cookies. However, if you use your browser settings to block all cookies (including essential cookies) you may not be able to access all or parts of OAGO.</p>
      </div>
    )
  }
}

export default CookiePolicy



// WEBPACK FOOTER //
// ./src/CookiePolicy.js